<template>
    <div>this is a list</div>
</template>
<script>
export default {
    
}
</script>